import { gql, useQuery } from '@apollo/client';
import { DateRangeValue } from '../../../shared/types';

const gqlQueryFilter = gql`
    query overviewCouponState {
        CITRIN_MGT_overviewCouponState @client
    }
`;
const typeName = 'CITRIN_MGT_overviewCouponState';

export type OverviewState = {
    search?: string;
    status?: boolean;
    selectedTypes?: string[];
    selectedDateRange?: DateRangeValue;
    page?: number;
};

const initialState: OverviewState = {
    search: '',
    status: true,
    selectedTypes: [],
    selectedDateRange: {
        fromDate: undefined,
        toDate: undefined,
    },
    page: 1,
};

export const useOverviewLinkState = (): [OverviewState, (newState: OverviewState) => void] => {
    const { data, client } = useQuery(gqlQueryFilter, { fetchPolicy: 'cache-first' });
    const setState = (newState: OverviewState) => {
        client.writeQuery({
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewCouponState: {
                    value: newState,
                    __typename: typeName,
                },
            },
        });
    };
    return [data?.CITRIN_MGT_overviewCouponState?.value ?? initialState, setState];
};

export default {
    defaults: [
        {
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewCouponState: {
                    value: initialState,
                    __typename: 'CITRIN_MGT_overviewCouponState',
                },
            },
        },
    ],
};
